import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { INote, Note, NoteType } from '../../../models/note';
import { EditorModule } from 'primeng/editor'
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-note-editor',
  standalone: true,
  imports: [EditorModule, InputTextModule, FloatLabelModule, FormsModule, NgIf, NgFor, DatePipe, ButtonModule, ButtonGroupModule, DividerModule, DropdownModule],
  templateUrl: './note-editor.component.html',
  styleUrl: './note-editor.component.scss'
})
export class NoteEditorComponent implements OnInit, OnChanges
{
  private _note: INote = {} as INote;
  private _originalNote!: INote;

  @Input()
  set note(val: INote)
  {
    this._note = val ? { ...val, noteTypes: [...(val.noteTypes ?? [])] } : {} as INote;
  }
  get note(): INote
  {
    return this._note;
  }

  @Input() editingNote: boolean = false;
  
  @Input() addendumMode: boolean = false;
  @Input() addendumNote?: Note;

  categoryOptions = [
    { label: "Finance",   value: NoteType.Finance },
    { label: "Nurse",     value: NoteType.Nurse },
    { label: "Manager",   value: NoteType.Manager }
  ];

  get isSticky(): boolean
  {
    return this.note.noteTypes?.includes(NoteType.Sticky) ?? false;
  }

  get category(): NoteType | undefined
  {
    return this.note.noteTypes?.find(t => t !== NoteType.Sticky);
  }

  set category(val: NoteType | undefined)
  {
    const sticky = this.isSticky;
    const types = val !== undefined ? [val] : [];
    this.note.noteTypes = sticky ? [...types, NoteType.Sticky] : types;
  }

  @Output() saved: EventEmitter<INote> = new EventEmitter<INote>();
  @Output() addendumSaved: EventEmitter<{noteId: number, body: string}> = new EventEmitter();
  @Output() cancelled: EventEmitter<void> = new EventEmitter<void>();
  @Output() deleted: EventEmitter<INote> = new EventEmitter();


  addendumBody: string = '';
  showPreviousAddenda: boolean = false;

  ngOnInit(): void {
    this._originalNote = structuredClone(this.note);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['note'] && !changes['note'].firstChange) {
      this._originalNote = structuredClone(this.note);
    }
  }

  reset() {
    this.note = { id: 0, subject: '', body: '', createdBy: {} as any, createDate: new Date(), noteTypes: [NoteType.Nurse] };
  }

  saveButtonPressed(_event: MouseEvent)
  {
    this._originalNote = structuredClone(this.note);
    this.note.body = this.normalizeBody(this.note.body ?? '');
    this.saved.emit(this.note);
  }

  saveAddendumPressed(event: MouseEvent)
  {
    if (this.addendumNote)
    {
      const body = this.normalizeBody(this.addendumBody);
      this.addendumSaved.emit({noteId: this.addendumNote.id, body});
      this.addendumBody = '';
    }
  }

  private normalizeBody(body: string): string
  {
    return body.replace(/<(p|div)><br><\/\1>/gi, '<br>');
  }

  cancelButtonPressed(event: MouseEvent)
  {
    Object.assign(this.note, this._originalNote);
    this.addendumBody = '';
    this.cancelled.emit();
  }

  deleteButtonPressed(_event: MouseEvent) {
    if (this.note.id !== 0) {
      this.deleted.emit(this.note);
    }
  }

  allowSave(): boolean
  {
    return (this.note.subject ?? '') != '' && (this.note.body ?? '') != '';
  }

  allowSaveAddendum(): boolean
  {
    return (this.addendumBody ?? '') != '';
  }
}
